export default "__VITE_ASSET__D9UOPwj6__"